module.exports = __webpack_public_path__ + "img/Proliferation-GBM_SPATA.576af647.png";